/**
 * ProtectedRoute — guard dla stron wymagajacych zalogowania.
 *
 * Jesli loading: pokazuje spinner.
 * Jesli !admin: redirect na /login.
 * W przeciwnym razie renderuje children.
 *
 * F5 dorzuci: requireRole, requireModule, requireCompanyContext.
 */

import { Navigate } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { admin, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500">Ładowanie sesji…</div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
